var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"text-primary fill-current",attrs:{"src":require("@/assets/images/logo/favicon.png"),"alt":"icone"}})}
var staticRenderFns = []

export { render, staticRenderFns }